


































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class GroupBar extends Vue {
  @Prop({ default: true })
  private clickable!: boolean;

  @Prop({ required: true })
  private title!: string;

  @Prop({ default: false })
  private initialOpen!: boolean;

  @Prop({ default: "" })
  private cssClass!: string;

  @Prop({ default: false })
  private sortable!: boolean;

  private isOpen = false;

  @Watch("initialOpen")
  public onInitialOpenChanged() {
    this.isOpen = this.initialOpen;
  }

  public toggle() {
    if (this.clickable) {
      this.isOpen = !this.isOpen;
    }
  }

  private created() {
    this.isOpen = this.initialOpen;
  }

  private get hasButtonSlot() {
    return !!this.$slots.button;
  }

  private get hasSecondButtonSlot() {
    return !!this.$slots.secondButton;
  }
}
